import { v4 as uuidv4 } from "uuid";
import { getBackgroundImageOptions } from "@/react/components/shared/BuilderUI/utils/backgroundHelpers";
import {
  getMarginOptions,
  getPaddingOptions,
} from "@/react/components/shared/BuilderUI/utils/boxModelStyleHelpers";
import { getBackgroundColorOptions } from "@/react/components/shared/BuilderUI/utils/buttonStyleHelpers";
import { getSizingOptions } from "@/react/components/shared/BuilderUI/utils/sizeStyleHelpers";
import { getColorOptions } from "@/react/components/shared/BuilderUI/utils/textStyleHelpers";
import { defaultData as defaultPData } from "@/react/components/shared/Emails/VisualEmailBuilder/Blocks/Content/PBlock/P1BlockDefaultData";
import type {
  BaseBlock,
  BaseProp,
} from "@circle-react-shared/BuilderUI/DataModel.types";
import { createImageBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/mediaBlockHelpers";
import {
  createH2Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import { getBorderRadiusOptions } from "@circle-react-shared/BuilderUI/utils/imgStyleHelpers";
import { defaultData as defaultImageData } from "@circle-react-shared/Emails/VisualEmailBuilder/Blocks/Content/ImgBlock/ImgBlockDefaultData";
import placeholderImage from "@circle-react-shared/Emails/VisualEmailBuilder/Blocks/Content/ImgBlock/img_preview_large.png";
import { defaultData as defaultH2Data } from "@circle-react-shared/Emails/VisualEmailBuilder/Blocks/Headings/H2Block/H2BlockDefaultData";
import { defaultStyles } from "./defaultStyles";

const sectionContentTemplate: BaseProp = {
  prop: "children",
  type: "children",
  value: [
    createImageBlock({
      signedId: "",
      placeholder: placeholderImage,
      baseData: defaultImageData,
      styles: {
        sizing: getSizingOptions({
          defaultValue: {
            maxHeight: "none",
            maxWidth: "100%",
            width: "100%",
            height: "187px",
            minHeight: "auto",
            minWidth: "auto",
          },
        }),
        margin: getMarginOptions({
          defaultValue: {
            marginTop: "12",
            marginBottom: "12",
            marginLeft: "24",
            marginRight: "24",
          },
        }),
        borderRadius: getBorderRadiusOptions({
          defaultValue: {
            border_left_top_radius: 20,
            border_left_bottom_radius: 20,
            border_right_top_radius: 20,
            border_right_bottom_radius: 20,
          },
        }),
      },
    }),
    createH2Block({
      text: "Heading",
      baseData: defaultH2Data,
      styles: {
        margin: getMarginOptions({
          defaultValue: {
            marginTop: "12",
            marginBottom: "12",
            marginLeft: "24",
            marginRight: "24",
          },
        }),
      },
    }),
    createPBlock({
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla, ut commodo diam libero vitae erat.",
      baseData: defaultPData,
      styles: {
        color: getColorOptions("#545861"),
        margin: getMarginOptions({
          defaultValue: {
            marginTop: "12",
            marginBottom: "12",
            marginLeft: "24",
            marginRight: "24",
          },
        }),
      },
    }),
  ],
};

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "FeatureBlock2",
  props: {
    headerContent: {
      prop: "children",
      type: "children",
      value: [],
    },
    section1Content: { ...sectionContentTemplate },
    section2Content: { ...sectionContentTemplate },
    footerContent: {
      prop: "children",
      type: "children",
      value: [],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        backgroundColor: getBackgroundColorOptions({
          defaultValue: defaultStyles.backgroundColor,
        }),
        backgroundImage: getBackgroundImageOptions(),
        padding: getPaddingOptions({
          defaultValue: defaultStyles.padding,
        }),
        margin: getMarginOptions({
          defaultValue: defaultStyles.margin,
        }),
      },
    },
  },
};
